
// @flow

import { TemporaryFileInfo } from 'temporary-file-info';


const temporaryFileInfoToJSMap = file => file && file.toJS();

const temporaryFileInfoFromJSMap = fileJS => {
	if (!fileJS) {
		return fileJS;
	}
	const file = new TemporaryFileInfo;
	file.fromJS(fileJS);
	return file;
};

const temporaryFileInfoToFromJSExtend = {
	toJSMap: temporaryFileInfoToJSMap,
	fromJSMap: temporaryFileInfoFromJSMap,
};

export {
	temporaryFileInfoToJSMap,
	temporaryFileInfoFromJSMap,
	temporaryFileInfoToFromJSExtend,
};